const s = {
  body: "'Nunito', ui-sans-serif, system-ui, -apple-system, sans-serif"
};
export {
  s as default
};
